import React from "react";
import { Check } from "lucide-react";

// Where they are in the journey. Clickable for stages already reached, so going
// back is one tap rather than a trail of Back buttons.
export default function JourneyProgress({ stages, current, furthest, skipped = [], onGo }) {
  return (
    <nav aria-label="Pricing journey progress" data-testid="pricing-progress">
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-2">
        {stages.map((label, i) => {
          const n = i + 1;
          const skip = skipped.includes(n);
          const done = n < current && !skip;
          const active = n === current;
          const reachable = n <= furthest && n !== current && !skip;
          return (
            <li key={label} className="flex items-center gap-1">
              <button
                type="button"
                disabled={!reachable}
                onClick={() => reachable && onGo(n)}
                data-testid={`pricing-progress-${n}`}
                aria-current={active ? "step" : undefined}
                className={`inline-flex items-center gap-2 rounded-full pl-2 pr-3.5 py-1.5 text-xs font-bold transition-colors ${
                  active
                    ? "bg-navy text-white"
                    : done
                      ? "text-orange-dark hover:bg-orange/10"
                      : "text-slate-400"
                } ${reachable ? "cursor-pointer" : "cursor-default"}`}
              >
                <span
                  className={`w-5 h-5 rounded-full inline-flex items-center justify-center text-[10px] ${
                    active ? "bg-white text-navy" : done ? "bg-orange text-white" : "bg-slate-100 text-slate-400"
                  }`}
                >
                  {done ? <Check size={11} strokeWidth={3} /> : n}
                </span>
                <span className="hidden sm:inline">{label}</span>
              </button>
              {n < stages.length && <span className="w-5 h-px bg-slate-200 hidden sm:block" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
